import React from 'react'
import ThemeSelector from '../../components/ThemeSelector'
import { useTheme } from '../../hooks/useTheme'

const ConfiguracionAdmin: React.FC = () => {
  const { colors } = useTheme()
  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Configuración</h1>
        <p className="text-gray-600 mt-2">Personaliza la apariencia y configuración de la plataforma</p>
      </div>

      {/* Secciones de configuración */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Panel de Temas */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <ThemeSelector />
        </div>

        {/* Panel de información adicional */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Sobre la aplicación</h3>
          <div className="space-y-4">
            <div>
              <p className="text-sm text-gray-600">Versión</p>
              <p className="text-lg font-medium text-gray-900">v2.0.0 (Pre-Release)</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Última actualización</p>
              <p className="text-lg font-medium text-gray-900">5 de Noviembre, 2025</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Resort</p>
              <p className="text-lg font-medium text-gray-900">Playa Niklitschek</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tarjeta de características */}
      <div className="p-6 rounded-lg border" style={{
        background: `linear-gradient(to right, ${colors.primary}10, ${colors.success}10)`,
        borderColor: colors.primary
      }}>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Características disponibles</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-start gap-3">
            <span className="text-2xl">📱</span>
            <div>
              <p className="font-medium text-gray-900">Diseño Responsivo</p>
              <p className="text-sm text-gray-600">Optimizado para dispositivos móviles y tablets</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-2xl">🎨</span>
            <div>
              <p className="font-medium text-gray-900">Temas Personalizables</p>
              <p className="text-sm text-gray-600">Elige entre múltiples paletas de colores</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-2xl">📅</span>
            <div>
              <p className="font-medium text-gray-900">Calendario Avanzado</p>
              <p className="text-sm text-gray-600">Vista de mes, semana y día con detalles de ocupación</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-2xl">💰</span>
            <div>
              <p className="font-medium text-gray-900">Gestión de Reservas</p>
              <p className="text-sm text-gray-600">Sistema completo de reservas y pagos</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfiguracionAdmin
